var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { loadImage,
// optimizeFile,
// isOverSize,
// validateUrl
 } from './Helper';
// import uniq from 'lodash/uniq'
// import { OverSizeImageError } from './Error'
var checkAspectRacio = function (width, height, widthRacio, heightRacio) {
    if (widthRacio === 1.91 && heightRacio === 1) {
        // 1.91 : 1 のときは割り切れないので、切り捨てを行う
        var racio = Math.round((width / height) * 100) / 100;
        if (racio === 1.91)
            return true;
        return false;
    }
    // それ以外の場合は通常の比率比較
    return (Math.round(width * heightRacio * 100) / 100 ===
        Math.round(height * widthRacio * 100) / 100);
};
/**
 * インフィードを登録するフォーム
 */
var InfeedMainImageFormModel = /** @class */ (function () {
    function InfeedMainImageFormModel(_a) {
        var name = _a.name, url = _a.url, width = _a.width, height = _a.height;
        this.name = name;
        this.url = url;
        this.width = width;
        this.height = height;
    }
    InfeedMainImageFormModel.isValid = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var checkFileSize, image;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkFileSize = function (file) {
                            if (file.size / 1024 > 500)
                                throw new Error('画像サイズが500kbを超えています。500kb以下の画像をアップロードしてください');
                            return true;
                        };
                        return [4 /*yield*/, loadImage(file)
                            // アスペクト比 1.91 : 1 (1200 x 628)
                        ];
                    case 1:
                        image = _a.sent();
                        // アスペクト比 1.91 : 1 (1200 x 628)
                        if (checkAspectRacio(image.naturalWidth, image.naturalHeight, 1.91, 1)) {
                            if (image.naturalWidth < 1200)
                                throw new Error('アスペクト比 1.91:1 の画像は、1200px以上の必要があります。');
                            if (checkFileSize(file))
                                return [2 /*return*/, true];
                        }
                        // アスペクト比 16 : 9 (1280 x 720)
                        if (checkAspectRacio(image.naturalWidth, image.naturalHeight, 16, 9)) {
                            if (image.naturalWidth < 1280)
                                throw new Error('アスペクト比 16:9 の画像は、横幅1280px以上の必要があります。');
                            if (checkFileSize(file))
                                return [2 /*return*/, true];
                        }
                        // アスペクト比 6 : 5 (600 x 500)
                        if (checkAspectRacio(image.naturalWidth, image.naturalHeight, 6, 5)) {
                            if (image.naturalWidth < 600)
                                throw new Error('アスペクト比 6:5 の画像は、600px以上の必要があります。');
                            if (checkFileSize(file))
                                return [2 /*return*/, true];
                        }
                        throw new Error("\n      1200 x 628px, 1280 x 720px, 600 x 500px\u306E\u3044\u305A\u308C\u304B\u306E\u753B\u50CF\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n    ");
                }
            });
        });
    };
    return InfeedMainImageFormModel;
}());
export { InfeedMainImageFormModel };
